import { render, staticRenderFns } from "./NewShopNoWebhookChat.vue?vue&type=template&id=5364fb55&scoped=true&"
import script from "./NewShopNoWebhookChat.vue?vue&type=script&lang=js&"
export * from "./NewShopNoWebhookChat.vue?vue&type=script&lang=js&"
import style0 from "./NewShopNoWebhookChat.vue?vue&type=style&index=0&id=5364fb55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5364fb55",
  null
  
)

export default component.exports